/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const DialogActionTemplate = `
    <button type="button" action-code="{{actionCode}}" class="{{classes}}" aria-label="{{localizedText}}">{{localizedText}}</button>
`;      
